
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/leftBar/menuButtonLabel/menuButtonLabel.scss.css.virtualfile';
        module.exports = {"label-box":"_label-box_ig60g_7","labelBox":"_label-box_ig60g_7"};